export default "__VITE_ASSET__BMb9IH_Y__"